import Button from "../../atoms/Button/Button";
import PartnerBand from "../../atoms/partnerBand/PartnerBand";
import RiskMapPreview from "../../molecules/RiskMapPreview/RiskMapPreview";
import "./MapPreviewSection.css";

const MapPreviewSection = () => (
  <section className="dark">
    <div className="wrap">
      <div className="center">
        <span className="eyebrow">Carte dynamique des risques</span>
        <h2>Une vigilance qui couvre chaque kilomètre carré du pays</h2>
      </div>
      <div className="map-preview-console">
        <PartnerBand />
        <RiskMapPreview
          title=""
          liveLabel=""
        />
      </div>
      <div style={{ textAlign: "center", marginTop: "28px" }}>
        <a href="/notifications" target="_blank" rel="noopener noreferrer">
          <Button label="Consulter la carte interactive" variant="primary" />
        </a>
      </div>
    </div>
  </section>
);

export default MapPreviewSection;
